export default __webpack_public_path__ + "eqp_seal.7e9a4b69a636fc16c4ce.png";